import { useEffect } from "react";
import { useToast } from "../../ui";
import { useNextT } from "../../i18n";
import { setMutationErrorHandler } from "../../data/queryClient";
import { showBlockedIfSo } from "./BlockedWhileViewingAs";

/**
 * Mount once inside the toast layer: any failed change that was refused "while viewing someone else's account" shows
 * that sentence as a toast, so no page needs wiring of its own. Other failures are left to the page.
 */
export const BlockedToastHost = () => {
  const toast = useToast();
  const { t } = useNextT();
  useEffect(() => {
    setMutationErrorHandler((err) => { showBlockedIfSo(err, toast, t); });
    return () => setMutationErrorHandler(null);
  }, [toast, t]);
  return null;
};
